import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { IPrintBehavior } from "../../../../documaker/domain/format/objects";

export interface IPrintBehaviorPropertyEditable {
  printBehavior(): IPropertyEditable<IPrintBehavior>;
}

export function instanceOfIPrintBehaviorPropertyEditable(instance: any): instance is IPrintBehaviorPropertyEditable {
  return instance
      && instance.printBehavior
      && instanceOfIPropertyEditable<IPrintBehavior>(instance.printBehavior());
}
